import contentitems from './content/items/sagas'

export default [contentitems]
